import { useState } from 'react'
import { FontPairing } from 'hooks/queries/fontPairings'
import { MediaFile } from 'components/VisualStylePreviewCarousel/VisualStylePreviewCarousel'
import { SelectionStage } from './SelectionStage'
import { StyleGenerated } from './GenerationStage'
import { useDisplayedFontPairingsAndVisualStyles } from './useDisplayedFontPairingsAndVisualStyles'

export interface BrandVisualStyleSelectionProps {
  onNext: (fontPairings: FontPairing[], generatedStyles: StyleGenerated[], sourceImage: MediaFile | null) => void
  onBack: () => void
  brandKitId?: number
}

export const BrandVisualStyleSelection = ({ onNext, onBack, brandKitId }: BrandVisualStyleSelectionProps) => {
  const [sourceImage, setSourceImage] = useState<MediaFile | null>(null)
  const { displayedFontPairings, displayedVisualStyles, isLoading } =
    useDisplayedFontPairingsAndVisualStyles(brandKitId)

  return (
    <SelectionStage
      onNext={(uploadedImage) => {
        const imageToPass = uploadedImage || sourceImage
        const generatedStyles = displayedVisualStyles.slice(0, 3).map((style) => ({
          styleUrl: style.cover_image_url,
          ...style,
        }))
        onNext(displayedFontPairings, generatedStyles, imageToPass)
      }}
      onSelectImage={(image) => {
        setSourceImage(image)
      }}
      isDisabled={isLoading}
      onBack={onBack}
      brandKitId={brandKitId}
    />
  )
}
